<template>
	<div>
		<!-- banner -->
		<div id="banner" class="banner">
			<!-- <el-carousel :height="bannerHeight+'px'"> -->
			<el-carousel :height="bannerHeight+'px'">
				<el-carousel-item v-for="(item, index) in sliders" :key="index">
					<img style="width:100%;height: auto" :src="item.img" class="slider_img"
						@click="getOpenMinChengXuLink">
				</el-carousel-item>
			</el-carousel>
			<!-- apply form -->
			<ApplyForm :title="title" :titleEngLish="titleEngLish" :clueType="clueType" @dialogFun="dialogFun"></ApplyForm>
		</div>
		<!-- 服务优势 -->
		<div class="head-label">
			<div class="f36">服务优势</div>
			<div class="f14 red">SERVICE ADVANTAGES</div>
		</div>
		<div class="border_parent service">
			<div class="service_a">
				<img src="../../static/home/advantage01.png" alt="" />
				<div class="service_t1">
					<p class="f24 blod">借款额高</p>
					<p class="f14 c-6">不查征信、只看物品价值、顶额借款满</p>
					<p class="f14 c-6">足客户需求</p>
				</div>
			</div>
			<div class="service_a">
				<img src="../../static/home/advantage02.png" alt="" />
				<div class="service_t2">
					<p class="f24 blod">放款迅速</p>
					<p class="f14 c-6">汽车业务1小时可到账、房产业务8小时</p>
					<p class="f14 c-6">可到账、在线民品典当秒到账</p>
				</div>
			</div>
			<div class="service_a">
				<img src="../../static/home/advantage03.png" alt="" />
				<div class="service_t1">
					<p class="f24 blod">方便灵活</p>
					<p class="f14 c-6">手续简便、随借随还、审批条件灵活</p>
				</div>
			</div>
			<div class="service_a">
				<img src="../../static/home/advantage04.png" alt="" />
				<div class="service_t2">
					<p class="f24 blod">专业可靠</p>
					<p class="f14 c-6">20余年专业品质、实力雄厚、典当行业</p>
					<p class="f14 c-6">协会会员单位</p>
				</div>
			</div>
		</div>
		<!--立即咨询 -->
		<div class="head-label seek">
			<a href="#banner" class="seek-btn">立即咨询</a>
			<!-- <div class="seek-btn">立即咨询</div> -->
		</div>
		<!-- 贷款流程 -->
		<Process></Process>
		<!-- 联丰门店 -->
		<Address></Address>
		<Dialog :centerDialogVisible="centerDialogVisible" @close="close"></Dialog>
	</div>
</template>
<script>	
	import ApplyForm from '../components/ApplyForm.vue'
	import Address from '../components/Address.vue'
	import Process from '../components/Process.vue'
	import Dialog from '../components/Dialog.vue'
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	export default {
		name: 'Index',
		components: {ApplyForm,Address,Process, Dialog},
		data() {
			return {
				centerDialogVisible: false,
				title: "借款申请",
				titleEngLish: 'BORROWING APPLICATION',
				clueType: 0,
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
				processArr: [{
						img: require('../../static/home/1.png'),
						title: "申请",
						name: '添加客服微信'
					},
					{
						img: require('../../static/home/2.png'),
						title: "评估",
						name: '提交物品详情'
					},
					{
						img: require('../../static/home/3.png'),
						title: "审核",
						name: '即时审批额度'
					},
					{
						img: require('../../static/home/4.png'),
						title: "放款",
						name: '借款迅速到账'
					},
				],
				// 热门问答
				questionsArr: [
					{
						title: '贷款小贴士',
						questions: [{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						},
						{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						}]
					},
					{
						title: '我能贷款吗',
						questions: [{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						},
						{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						}]
					},
					{
						title: '如何还款',
						questions: [{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						},
						{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						}]
					}
				],
				// 链接
				linkArr: [
					{
						icon: require('../../static/home/quick_links01.png'),
						name: '快速申请',
					},
					{
						icon: require('../../static/home/quick_links02.png'),
						name: '渠道合作',
					},
					{
						icon: require('../../static/home/quick_links03.png'),
						name: '典当问答',
					},
					{
						icon: require('../../static/home/quick_links04.png'),
						name: '门店信息',
					}
				],
				// 合作机构
				cooperate: [require('../assets/logo.png'),require('../assets/logo.png'),require('../assets/logo.png'),require('../assets/logo.png')],
				images: [{
						img: require('../../static/other/店铺管理.png'),
						title: "提交申请",
						content: ["在线提交资料", "一对一匹配客服"]
					},
					{
						img: require('../../static/other/店铺管理.png'),
						title: "提交申请",
						content: ["在线提交资料", "一对一匹配客服"]
					},
					{
						img: require('../../static/other/数据分析.png'),
						title: "查询报价",
						content: ["系统自动检测估价", "专业检测师免费评估"]
					}, {
						img: require('../../static/other/用户构建.png'),
						title: "当面评估",
						content: ["全程免费为您服务", "允许可免费上门服务"]
					},
					{
						img: require('../../static/other/品牌渠道.png'),
						title: "快速寄存",
						content: ["专柜封存", "简单 方便 快捷 安全"]
					}
				],
				spec: {
					img: require('../../static/other/arrow.png'),
					product: [{
							img: require('../../static/other/手指.png'),
							title: "一键操作",
							contents: ["一键延期或买回", "操作方便快捷安全"]
						},
						{
							img: require('../../static/other/店铺管理.png'),
							title: "一键延期",
							contents: ["系统实时监控寄存状态", "自动检测延期金额和差价"]
						},
						{
							img: require('../../static/other/用户构建.png'),
							title: "一键买回",
							contents: ["校验买回码", "支付买回费用"]
						},
						{
							img: require('../../static/other/助力零售.png'),
							title: "平台核查",
							contents: ["检测师核对买回信息", "顺丰发货业务灵活方便"]
						}
					]
				},
				// carousel_height: '550px',
			}
		},
		created() {},
		methods: {
			dialogFun(flag) {
				this.centerDialogVisible = flag
			},
			close(flag) {
				this.centerDialogVisible = flag
			},
			getOpenMinChengXuLink() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					console.log('pc端不跳转')
					return;
				}

			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			}
		},
		mounted() {
			this.sliders = [{
					img: require("../../static/home/我要典当banner.png")
				}],
				// 首次加載時，初始化高度
				this.screeWith = window.innerWidth
			this.bannerHeight = 560 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 560 / 1920 * this.screeWith
			}
		},
		computed: {
			//计算高度
			// computeHeight() {
			//     let screenHeight = document.body.clientWidth;
			//     if (screenHeight > 415) {
			//         return '550px';
			//     } else {
			//         return '250px';
			//     }
			// },
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require('../../static/other/arrow.png');
				} else {
					return require('../../static/other/arrow_down.png');
				}
			}

		},
	}
</script>

<style scoped>
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #CF2427 !important;
	}
	
	.slider_img {
		height: 560px;
		width: 100%;
	}

	/* banner FORM style */
	.banner {
		position: relative;
	}
	
	
	.solve {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.border {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		height: auto;
		margin: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.border_one {
		margin-left: 0;
	}

	.border_img_parent {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}

	.product_mobile_content {
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.product_mobile_img {
		width: 50%;
	}

	.product_mobile_title {
		font-weight: bold;
		text-align: center;
	}

	.product_pc_one {
		text-align: center;
		min-height: 400px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.font_size_30 {
		font-size: 1.875rem;
	}

	.product_font_style {
		font-size: 1.125rem;
	}

	.product_pc_img {
		width: 100%
	}

	.product_pc_img_div {
		width: 50%;
		float: left;
		display: flex;
		align-items: center;
	}

	.product_pc {
		display: flex;
		width: 90%;
		margin: 20px auto;
		background: #F2F6FC;
		align-items: center;
	}

	.product_spec_title {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.cooperation_parent {
		display: flex;
		justify-content: center;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.border_spec {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		float: left;
		width: 25%;
		height: auto;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.about_me_p {
		font-size: 1.25rem;
		font-weight: normal;
		padding: 0 20px;
		margin: 10px;
	}

	.border_title {
		font-family: "PingFang SC";
		margin-top: 10px;
		font-size: 1.125rem;
		font-weight: bold;
		text-align: center;
	}

	.border_content_one {
		margin-top: 20px;
		font-size: 1.125rem;
		text-align: center;
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125rem;
		margin-bottom: 25px;
		text-align: center;
	}

	.img_border {
		margin-top: 15px;
		width: 80px;
		height: 80px
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 35px;
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		text-align: center;
	}

	.border_spec_inner_last {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		margin-bottom: 25px;
		text-align: center;
	}

	.cooperation {
		margin-top: 30px;
		width: 100%;
	}

	.about_me {
		display: flex;
		margin-top: 30px;
		justify-content: center;
		width: 100%;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		background: #F2F6FC;
	}

	.product_mobile_img_div {
		width: 50%;
		height: auto;
	}

	.product_mobile_content_one {
		margin-top: 20px;
		text-align: center;
	}

	.product_mobile_content_two {
		margin-top: 10px;
		text-align: center;
	}

	/* 屏幕设备适配 max-device-width: 400px */
	@media screen and (max-device-width: 415px) {
		.slider_img {
			height: 250px;
			width: 100%;
		}


		.border_parent {
			display: flex;
			width: 90%;
			margin: auto;
			height: auto;
			flex-direction: column;
		}

		.border {
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			float: left;
			width: 100%;
			height: auto;
			margin: 10px 0 auto;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
				/*background: aquamarine;*/
		}

		.border_img_parent {
			margin-top: 0;

		}

		.product_mobile {
			width: 90%;
			align-items: center;
			margin: 20px auto;
			height: auto;
			background: #F2F6FC;
		}

		.product_mobile_content {
			width: 100%;
			margin-top: 15px;
		}

		.product_mobile_content_one {
			margin-top: 5px;
		}

		.product_mobile_content_two {
			margin-top: 5px;
		}

		.product_mobile_img_div {
			display: flex;
			width: 100%;
			height: auto;
			justify-content: center;
			margin-top: 10px;
			margin-bottom: 15px;
		}

		.product_mobile_img {
			float: left;
		}

		.product_mobile_title {
			font-weight: bold;
		}

		.product_pc_one {
			width: 100%;
			margin-top: 15px;
		}

		.font_size_30 {
			font-size: 1.25rem;
		}

		.product_font_style {
			font-size: 1rem;
		}

		.product_pc_img {
			height: 280px;
			width: 320px;
		}

		.product_pc_img_div {
			width: 100%;
			float: left;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 15px;
		}

		.product_pc {
			display: flex;
			width: 90%;
			height: auto;
			margin: 20px auto;
			background: #F2F6FC;
			flex-direction: column;
		}

		

		.product_spec_parent {
			display: flex;
			width: 90%;
			align-items: center;
			justify-content: center;
			margin: 20px auto;
			height: auto;
			flex-direction: column;
		}

		.border_spec {
			float: left;
			height: auto;
			margin: 8px;
			width: 100%;
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		}


		.border_title {
			font-family: "PingFang SC";
			margin-top: 5px;
			font-size: 1.125rem;
			font-weight: bold;
		}

		.border_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
		}

		.border_content_two {
			margin-top: 5px;
			font-size: 1.125rem;
			margin-bottom: 8px;
		}

		.img_border {
			margin-top: 8px;
			width: 80px;
			height: 80px
		}

		.border_spec_inner_one {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 8px;
			/*background-color: aqua;*/
			height: 70px;
		}

		.border_spec_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
		}

		.border_spec_inner_last {
			/*background-color: bisque;*/
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
			margin-bottom: 8px;
		}

		.about_me {
			display: flex;
			margin-top: 10px;
			width: 100%;
		}
	}

	.border_spec_img {
		width: 75px;
		height: 55px;
		align-self: center
	}

	.font_size_24 {
		font-size: 1.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/view/myPawn.vue